import { Chip } from '@mui/material';
import React from 'react';

export const truncateText = (text, maxLength = 30) => {
  if (!text) return '-';
  return text.length > maxLength ? `${text.substring(0, maxLength)}...` : text;
};

export const getStatusBadge = (isActive) => {
  if (isActive === true) {
    return (
      // <div className="badge badge-accent badge-success badge-sm">Active</div>
        <Chip
        label="Active"
        color="success"
        size="small"
        variant="filled"
        sx={{ fontWeight: 500 }}
      />
    );
  } else {
    return (
      // <div className="badge badge-soft badge-error badge-sm">Inactive</div>
        <Chip
        label="Inactive"
        color="error"
        size="small"
        variant="outlined"
        sx={{ fontWeight: 500 }}
      />
    );
  }
};
